// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// IMPORT PROJECT REFERENCES
import { logout } from '../state/actions/AuthActions';

// COMPONENT

class LogoutComponent extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate() {
        console.log('LogoutComponent', this.props);
        this.props.logout();
        return true;
    }

    render() {
        const loginFormStyle = {
            padding: '25px',
        };

        return (
            <div className="row h-100 align-items-center justify-content-center">
                <div style={loginFormStyle} className="card col-6 my-auto">
                    <div className="col-12">
                        <h2 className="text-center">You Are Now Logged Out</h2>
                    </div>
                </div>
            </div>
        );
    }
}

LogoutComponent.propTypes = {
    logout: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

const hoc = connect(mapDispatchToProps)(LogoutComponent);
export { hoc as LogoutComponent };
